<template>
	<div class="billing_displayer">
		<h4 id="displayer__title">Récapitulatif</h4>
		<p>Prix du client : {{ totalPrice }} €</p>
		<p>Prix moins les masses : <strong>{{ priceWithMasses }} €</strong></p>
		<p :class="this.priceColor">Total des honoraires : <strong>{{ totalDispatchedPrice }} €</strong></p>
	</div>
</template>

<script>
export default {

  name: 'billingPriceComponent',
  props: ['userprices','externalprices'],
  data () {
    return {
    	'totalPrice': 0,
    	'userPrice' : this.userprices,
    	'externalPrice' : this.externalprices,
    	'comission': 0
    }
  },
  mounted () {
  	this.$parent.$on('update:totalDispatchedPrice', (e) => {
  		if (e.type == 'user') {
  			this.userPrice = e.quantity
  		} else if(e.type == 'reinforcement') {
  			this.externalPrice = e.quantity
  		} else {
  			this.totalPrice = e.quantity
  		}
  	}),
    this.$parent.$on('update:comission', (e) => {
      this.comission = e.quantity
    })
  },
  computed : {
  	totalDispatchedPrice() {
  		return this.userPrice + this.externalPrice
  	},
  	priceColor(){
  		if (this.totalDispatchedPrice > this.priceWithMasses) {
  			return 'red'
  		} else if (this.totalDispatchedPrice < this.priceWithMasses) {
  			return 'orange'
  		} else {
  			return 'green'
  		}
  	},
  	priceWithMasses() {
  		return this.totalPrice - ((this.totalPrice / 100) * this.comission)
  	}
  },
  method: {
  	dispatchUpdate() {
  		this.totalPrice = 100
  	}
  }
}
</script>

<style lang="css" scoped>
.billing_displayer{
	width: 25rem;
	position: fixed;
	background-color: white;
	right: 0;
	top: 12rem;
	border-radius: 5px 0 0 5px!important;
	box-shadow: 0px 0px 20px 0px rgba(0,0,0,0.40);
	z-index: 1000;
}

.billing_displayer p{
	margin-left: 2rem;
}

#displayer__title{
	background-color: #26344b;
	margin: 0;
	padding: 1rem;
	border-radius: 5px 0 0 0!important;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	color: white;
	font-weight: 500;
}

.orange{
	color: #ff6600;
}

.red{
	color: #ff0000;
}

.green{
	color: #009933;
}
</style>
